import { render, staticRenderFns } from "./InfoLoader.vue?vue&type=template&id=70e687a7"
import script from "./InfoLoader.vue?vue&type=script&lang=js"
export * from "./InfoLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports